/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:1bcba991-6636-48cf-ac94-e30ac70c4758",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_V6OkKaQ83",
    "aws_user_pools_web_client_id": "3rs0dcpnt77bskdk6lm4fssodc",
    "oauth": {
        "domain": "amplifycongitoauth-go-sm-euc1.auth.eu-central-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_graphqlEndpoint": "https://pcc4uyrpibaqzg6cogbq4hvfyu.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_cloud_logic_custom": [
        {
            "name": "GetProductsRestAPI",
            "endpoint": "https://wzt646xkn2.execute-api.eu-central-1.amazonaws.com/master",
            "region": "eu-central-1"
        }
    ],
    "aws_content_delivery_bucket": "awsdrtool-hostingbucket-771545217607-eu-central-1-master",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d1ny071k54sceh.cloudfront.net"
};


export default awsmobile;
